var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.669317 0C0.397522 0 0.154336 0.157671 0.0529 0.39728C-0.0498359 0.63689 0.0112854 0.911261 0.205054 1.09128L6.39263 6.99834L0.205054 12.9054C0.0307924 13.0643 -0.0394323 13.3014 0.021689 13.5249C0.0828106 13.7471 0.264875 13.9209 0.497657 13.9793C0.731739 14.0376 0.980127 13.9706 1.14659 13.8042L7.80493 7.44776C8.06502 7.19946 8.06502 6.79721 7.80493 6.54891L1.14659 0.192433C1.02044 0.069524 0.84878 0 0.669317 0Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.6c3e3e83292c3da6d6d9dae5c6818d7a.svg";
export { ForwardRef as ReactComponent };